export type ActivityTone = 'blue' | 'yellow' | 'green'

export interface PurchaseActivity {
  id: string
  initials: string
  name: string
  location: string
  packageName: string
  tone: ActivityTone
  timeAgo: string
}

export const purchaseActivity: PurchaseActivity[] = [
  {
    id: 'miguel',
    initials: 'MR',
    name: 'Miguel R.',
    location: 'Indiana',
    packageName: 'Paquete Pro',
    tone: 'yellow',
    timeAgo: 'hace 4 min',
  },
  {
    id: 'sofia',
    initials: 'ST',
    name: 'Sofía T.',
    location: 'Texas',
    packageName: 'Paquete Elite',
    tone: 'green',
    timeAgo: 'hace 9 min',
  },
  {
    id: 'carlos',
    initials: 'CM',
    name: 'Carlos M.',
    location: 'Florida',
    packageName: 'Paquete Esencial',
    tone: 'blue',
    timeAgo: 'hace 12 min',
  },
  {
    id: 'ana',
    initials: 'AG',
    name: 'Ana G.',
    location: 'California',
    packageName: 'Paquete Pro',
    tone: 'yellow',
    timeAgo: 'hace 18 min',
  },
  {
    id: 'luis',
    initials: 'LP',
    name: 'Luis P.',
    location: 'Arizona',
    packageName: 'Paquete Pro',
    tone: 'yellow',
    timeAgo: 'hace 23 min',
  },
  {
    id: 'daniela',
    initials: 'DV',
    name: 'Daniela V.',
    location: 'Nevada',
    packageName: 'Paquete Elite',
    tone: 'green',
    timeAgo: 'hace 31 min',
  },
  {
    id: 'jose',
    initials: 'JN',
    name: 'José N.',
    location: 'Illinois',
    packageName: 'Paquete Esencial',
    tone: 'blue',
    timeAgo: 'hace 38 min',
  },
  {
    id: 'lucia',
    initials: 'LH',
    name: 'Lucía H.',
    location: 'Georgia',
    packageName: 'Paquete Pro',
    tone: 'yellow',
    timeAgo: 'hace 46 min',
  },
]

export const activityToneStyles: Record<
  ActivityTone,
  { avatar: string; pkg: string }
> = {
  blue: {
    avatar: 'bg-[linear-gradient(135deg,#1B4DCC,#071F5C)] text-white',
    pkg: 'text-brand-blue',
  },
  yellow: {
    avatar: 'bg-[linear-gradient(135deg,#FFD500,#B98900)] text-brand-deep',
    pkg: 'text-[#B98900]',
  },
  green: {
    avatar: 'bg-[linear-gradient(135deg,#22C55E,#16883F)] text-white',
    pkg: 'text-[#16883F]',
  },
}
